import {
  FundAdditionalAttributesModel,
  type ProjectModel,
} from '@/features/project/projects/_models/project';
import type { FC } from 'react';
import type { z } from 'zod';
import { FundAdditionalAttributesLocalGovernment } from './FundAdditionalAttributesLocalGovernment';
import { FundAdditionalAttributesStandard } from './FundAdditionalAttributesStandard';

type Props = z.infer<typeof ProjectModel>;

export const FundAdditionalAttributes: FC<Props> = (project) => {
  const parsed = FundAdditionalAttributesModel.safeParse(
    project.fundAdditionalAttributes,
  );

  if (!parsed.success) {
    return null;
  }

  switch (parsed.data.fundSheetType) {
    case 'standard':
      return <FundAdditionalAttributesStandard {...project} />;

    case 'local-government':
      return <FundAdditionalAttributesLocalGovernment {...project} />;

    default:
      return null;
  }
};
